import HelixSearchInsightItem from './HelixSearchInsightItem'

type Props = {
    total: number
    matchesCriteria: number
    inNetwork: number
    matchesBoth: number
    compact?: boolean
}

export default function HelixSearchInsights({
    total,
    matchesCriteria,
    inNetwork,
    matchesBoth,
    compact = false,
}: Props) {
    return (
        <div className="flex gap-4 justify-center flex-wrap">
            <HelixSearchInsightItem
                label="Total Candidate Pool"
                value={total}
                compact={compact}
            />
            <HelixSearchInsightItem
                label="Matching Job Criteria"
                value={matchesCriteria}
                compact={compact}
            />
            <HelixSearchInsightItem
                label="In Network"
                value={inNetwork}
                compact={compact}
            />
            <HelixSearchInsightItem
                label="Matching Job Criteria & In Network"
                value={matchesBoth}
                compact={compact}
            />
        </div>
    )
}
